exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filter[data-v-189b1988] {\n  font-size: 0.8em;\n}\n@media screen and (max-width: 1024px) {\n.filter[data-v-189b1988] {\n      display: none;\n}\n}\n.filter .items .item[data-v-189b1988] {\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    display: flex;\n    align-items: center;\n    padding: 1.25em;\n    transition: background-color 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.filter .items .item.active[data-v-189b1988] {\n      background: #E0E6ED;\n}\n", ""]);

// exports
